import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoVideoItems from 'eco-design/sections/eco-video-items';
import { EcoVideoItemsItemProps } from 'eco-design/sections/eco-video-items/EcoVideoItem';
import styles from './index.module.scss';
export default function Comp() {
    const { t } = useLang('theProduct.ListA2');
    const itemsA: EcoVideoItemsItemProps[] = [
        {
            logoIcon: 'https://websiteoss.ecoflow.com/upload/image/1740990284875/user_avatar_1.png',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1740990192290/users_saying_1.jpg',
            videoSrc: 'https://www.youtube.com/embed/MgJ3-Wr-q2I?si=VsL6ZmztZlIpxhyc',
            title: t('item1_title'),
            useName1: t('item1_desc1'),
            useName2: t('item1_desc2'),
        },
        {
            logoIcon: 'https://websiteoss.ecoflow.com/upload/image/1740990285051/user_avatar_3.png',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1740990192449/users_saying_3.jpg',
            videoSrc: 'https://www.youtube.com/embed/yZavrHJsBAw?si=xCammue97ivCgGPc',
            title: t('item2_title'),
            useName1: t('item2_desc1'),
            useName2: t('item2_desc2'),
        },
        {
            logoIcon:
                'https://websiteoss.ecoflow.com/upload/image/1745315553295/%E6%96%B0%E5%A8%98vs%E5%A9%86%E5%A9%86%E5%92%8C%E9%9C%B2%E8%90%A5%E8%BD%A6%E4%B8%80%E8%B5%B7%E4%BD%8F%20-%20YouTube%201.jpg',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745315553469/image%205154517.jpg',
            videoSrc: 'https://www.youtube.com/embed/46tClGo2S0U',
            title: t('item3_title'),
            useName1: t('item4_desc1'),
            useName2: t('item4_desc2'),
        },
        {
            logoIcon: 'https://websiteoss.ecoflow.com/upload/image/1745315553073/Outdoorbase_asobi%20-%20YouTube%201.jpg',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745315552918/1928.jpg',
            videoSrc: 'https://www.youtube.com/embed/I6X53Gg4fho',
            title: t('item4_title'),
            useName1: t('item3_desc1'),
            useName2: t('item3_desc2'),
        },
    ];

    return (
        <div className={` ${styles.comp}`}>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} desc={t('desc')} sectionCommonLayout="left" />
            <EcoSpaceSmall />
            <EcoVideoItems
                items={itemsA}
                dataLayerVideo={{
                    event: 'uaEvent',
                    event_name: 'video',
                    position: 'Product Collections_lisaA2',
                }}
            />
            <EcoSpace />
        </div>
    );
}
